import React from 'react';
import {ScrollView, StyleSheet, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import TouchableOpacity from '/component/base/TouchableOpacity';

const styles = StyleSheet.create({
  text: {
    backgroundColor: 'red',
  },
});

storiesOf('base', module).add('TouchableOpacity', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>TouchableOpacity</Heading>
        <Spacer size={24} />
        <Text>
          The <Code>TouchableOpacity</Code> component simply overrides the React
          Native TouchableOpacity component, passing through props that we don't
          want to modify, while overriding others to apply a consistent app-wide
          feel. It should be used in place of the React Native component in
          almost all cases.
        </Text>
        <Spacer size={16} />
        <Text>
          Currently, the only prop that we override is{' '}
          <Code>activeOpacity</Code>, which is set to 70%.
        </Text>
        <Spacer size={24} />
        <TouchableOpacity>
          <Text style={styles.text}>Touchable Opacity</Text>
        </TouchableOpacity>
      </FlexView>
    </Spacing>
  </ScrollView>
));
